export interface IProjectTableItem {
  key: number;
  category: string;
  title: string;
  description: string;
  status: string;
}

export const projectsDataMapper = (unmappedData: IProjectTableItem[]) =>
  unmappedData.map((item) => [
    item.key,
    item.category,
    { id: item.key, name: item.title },
    item.description,
    item.status,
  ]);

export const projectsColumns = [
  { title: "key", key: "key", visible: false, orderable: false },
  { title: "category", key: "category", orderable: true, filterable: false },
  {
    title: "title",
    key: "title",
    orderable: true,
    filterable: false,
    render: (data: any) => {
      return `
        <a href="/projects/${data.id}" style="color: #f58921; text-decoration: underline; cursor: pointer;">
          ${data.name}
        </a>
      `;
    },
  },
  { title: "description", key: "description", orderable: true, filterable: false },
  { title: "status", key: "status", orderable: true, filterable: false },
];
